"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSetting_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserSetting_Factory = /** @class */ (function () {
    function UserSetting_Factory() {
    }
    UserSetting_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Key: model.Key,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            Value: model.Value,
        };
        return result;
    };
    UserSetting_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Key: model.Key,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            Value: model.Value,
        };
        return result;
    };
    return UserSetting_Factory;
}());
exports.UserSetting_Factory = UserSetting_Factory;
